import React from "react"
import { DckActionCreators, DckSelectors } from "dck-redux"
import * as ItemTypes from "../../../redux/items/types"
import { connect } from "react-redux"
import PropTypes from "prop-types"

class ManageFinancierBucket extends React.Component {

  componentDidMount() {
    const { params: { id }, setCurrentId, reloadFinancierBucket } = this.props
    setCurrentId(id)
    reloadFinancierBucket(id)
  }

  render() {
    const { financierBucket, callback, setFinancierBucket, removeFinancierBucket } = this.props
    return financierBucket
      ? callback(financierBucket, setFinancierBucket, removeFinancierBucket)
      : <p>Loading ..</p>
  }
}

ManageFinancierBucket.propTypes = {
  financierBucket: PropTypes.object,
  setCurrentId: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired
}

const mapStateToProps = (state, ownProps) => {
  const financierBucket = DckSelectors.selectItemById(state, ItemTypes.FinancierBucket, ownProps.params.id)
  return { financierBucket }
},

mapDispatchToProps = dispatch => ({
  setCurrentId: id => dispatch(DckActionCreators.itemMakeActive(ItemTypes.FinancierBucket, id)),
  setFinancierBucket: (id, data) => dispatch(DckActionCreators.itemSet(ItemTypes.FinancierBucket, id, data)),
  reloadFinancierBucket: id => dispatch(DckActionCreators.itemReload(ItemTypes.FinancierBucket, id)),
  removeFinancierBucket: id => dispatch(DckActionCreators.itemRemove(ItemTypes.FinancierBucket, id)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ManageFinancierBucket)



// WEBPACK FOOTER //
// ./src/components/Financiers/Buckets/ManageItem.js